import { render, staticRenderFns } from "./EventAside.vue?vue&type=template&id=50ffa05f&scoped=true"
import script from "./EventAside.vue?vue&type=script&lang=js"
export * from "./EventAside.vue?vue&type=script&lang=js"
import style0 from "./EventAside.vue?vue&type=style&index=0&id=50ffa05f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ffa05f",
  null
  
)

export default component.exports